<nav class="main-header navbar navbar-expand navbar-white navbar-light" style="margin-left: 0px; padding-left: 0;">
  <ul class="navbar-nav d-block d-sm-block d-md-block d-lg-none d-xl-none">
    <li class="nav-item">
      <a class="nav-link" (click)="toggleMenuSidebar.emit()" role="button">
        <i class="fas fa-bars"></i>
      </a>
    </li>
  </ul>
  <a [routerLink]="['/']">
  <img
      src={{logoUrl}}
      alt="UConsole Logo"
      class="brand-image"
    /></a>

  <ul class="navbar-nav ml-auto" *ngIf="icon">
    <li class="nav-item">
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        data-widget="control-sidebar"
        data-slide="true"
        [routerLink]="['/contract-corp-reference']"
        role="button"
        style="padding-right: 0px;"
      >
        <i class="pinkI-usercircle"></i>
      </a>
    </li>
    <li class="nav-item">
      <h1
        [routerLink]="['/contract-corp-reference']"
        class="text"
      >
      {{company_name}}<br>{{user_name}}{{ 'COMMON.MR' | translate }}
      </h1>
    </li>
  </ul>
</nav>